import { apiFunction } from "../../../apiCalls/function";
import * as APIs from "../../../apiCalls/urls/officer/urls";


export const addSchoolImage = async (data) => {
    return await apiFunction(APIs.ADD_SCHOOL_IMAGE, "post", data, true, "admin")
}
